const relative = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 365 * 24 * 3600],
  ["month", 30 * 24 * 3600],
  ["week", 7 * 24 * 3600],
  ["day", 24 * 3600],
  ["hour", 3600],
  ["minute", 60],
  ["second", 1],
];

/** "3 minutes ago", "in 2 days"; an em dash for null. */
export const formatRelative = (iso: string | null): string => {
  if (!iso) {
    return "—";
  }
  const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
  const [unit, size] = UNITS.find(
    ([, unitSeconds]) => Math.abs(seconds) >= unitSeconds,
  ) ?? ["second", 1];
  return relative.format(Math.round(seconds / size), unit);
};

/** "1 mock", "3 mocks". */
export const pluralize = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? "" : "s"}`;

/** Local date and time, for tooltips. */
export const formatDateTime = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleString() : "";

/** Whether an expiry is in the past. */
export const isExpired = (iso: string | null): boolean =>
  iso !== null && new Date(iso).getTime() <= Date.now();

/** Pretty-prints JSON text; returns the input when it isn't JSON. */
export const prettyJson = (text: string | null): string => {
  if (!text) {
    return "";
  }
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch {
    return text;
  }
};
